class FileUploadError extends Error {
  static defaultMaxUploadMb = 15

  static ERROR_MESSAGES = {
    INVALID_FILE_TITLE: "Das hat leider nicht geklappt",
    INVALID_FILE_DESCRIPTION: "Keine Datei zum Validieren bereitgestellt",
    FILE_TOO_LARGE: (maxSize) =>
      `Deine Bilddatei scheint zu groß zu sein – wir können derzeit nur Fotos mit einer maximalen Dateigröße von ${maxSize} MB verarbeiten. Bitte versuche es erneut. Falls Du Hilfe brauchst, melde Dich gern bei unserem Support-Team.`,
  }

  title
  description
  maxUploadMb

  constructor({ title, description, maxUploadMb } = {}) {
    const defaultTitle = FileUploadError.ERROR_MESSAGES.INVALID_FILE_TITLE
    const defaultDescription =
      FileUploadError.ERROR_MESSAGES.INVALID_FILE_DESCRIPTION
    const defaultMaxSize = FileUploadError.defaultMaxUploadMb

    super(title ?? defaultTitle)
    this.name = "FileUploadError"
    this.title = title ?? defaultTitle
    this.description = description ?? defaultDescription
    this.maxUploadMb = maxUploadMb ?? defaultMaxSize

    Object.setPrototypeOf(this, new.target.prototype)
  }

  static throw(options) {
    throw new FileUploadError(options)
  }

  static throwInvalidFile() {
    return FileUploadError.throw({
      title: FileUploadError.ERROR_MESSAGES.INVALID_FILE_TITLE,
      description: FileUploadError.ERROR_MESSAGES.INVALID_FILE_DESCRIPTION,
    })
  }

  static throwFileTooLarge(maxUploadMb = FileUploadError.defaultMaxUploadMb) {
    return FileUploadError.throw({
      maxUploadMb,
      description: FileUploadError.ERROR_MESSAGES.FILE_TOO_LARGE(maxUploadMb),
    })
  }
}

const validateUploadSize = ({
  file,
  maxUpload = FileUploadError.defaultMaxUploadMb,
}) => {
  if (!file) {
    FileUploadError.throwInvalidFile()
  }

  if (file.size > maxUpload * 1024 * 1024) {
    FileUploadError.throwFileTooLarge(maxUpload)
  }
}

export { FileUploadError, validateUploadSize }
